import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { GridSelect } from '../grid.component';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'neoris-filter-component',
  templateUrl: './filter-component.component.html',
  styleUrls: ['./filter-component.component.css']
})
export class FilterComponentComponent implements OnInit {

  public _filterValues: GridSelect[] = []
  public filteredFilterValues!: Observable<GridSelect[]> | undefined;
  public allComplete: boolean = true;

  @Input()
  set FilterValues(_filterValues: GridSelect[]) {
    
    this._filterValues = _filterValues

    // this.filteredFilterValues = of( _filterValues)
  }

  filterForm: UntypedFormGroup = this.fb.group({
    inputFilter: ['']
  })

  constructor(private fb: UntypedFormBuilder,
    private el: ElementRef
  ) { }

  ngOnInit(): void {
    this.filteredFilterValues = this.filterForm.get('inputFilter').valueChanges.pipe(
      startWith(''),
      map(value => {
        let filter = this._filterValuesFilter(value)

        return (value ? filter : this._filterValues.slice())
      })
    )
  }

  private _filterValuesFilter(input: string): GridSelect[]{
    const filterValue = input.toLocaleLowerCase()
    return this._filterValues.filter(f => f.value.toLocaleLowerCase().includes(filterValue))
  }

  @ViewChild('myCheckBox') selectList: any;

  public onKeyUp(event: any){
    if(event.code == 'Enter'){
      const elements = this.el.nativeElement.getElementsByClassName('check');
      
      for (let i = 0; i < elements.length; i++) {
        const check: HTMLElement = elements[i]
        if(check.classList.contains('mat-checkbox-checked')){
          console.log(check.innerText)
        }

      }


      
    }
  }
  // applyFilterEvent(event: Event) {
  //   const _filterValue = (event.target as HTMLInputElement).value;
  //   this.applyFilter(_filterValue)
  //   // const filterValue = (event.target as HTMLInputElement).value;
  //   // this.dataSource.filter = filterValue.trim().toLowerCase();

  //   // if (this.dataSource.paginator) {
  //   //   this.dataSource.paginator.firstPage();
  //   // }
  // }

  // applyFilter(value: string) {
  //   const filterValue = value.trim().toLowerCase();
  //   let filter = this._filterValuesFilter(filterValue)

  //   this.filteredFilterValues = of(filterValue ? filter : this._filterValues.slice())
  // }

  SelectAll(){
    console.log("test")
  }

}
